<template>
  <vuex-table :fields="fields" table_store="mailer/senders/table">
    <template slot="status" slot-scope="{ item }">
      <state-badge
        v-if="!!updated_senders.find((sender) => sender.id === item.id)"
        :value="updated_senders.find((sender) => sender.id === item.id).status"
      />
      <state-badge v-else :value="item.status" />
    </template>

    <template slot="actions" slot-scope="{ item }">
      <tooltip
        v-if="needShowDeactivate(item)"
        placement="left"
        theme="light"
        :content="$t('mailer.sender.table.deactivate')"
      >
        <table-control type="trash" @click="deactivate(item)" />
      </tooltip>
      <tooltip
        v-else-if="item.status === 'active'"
        placement="left"
        theme="light"
        :content="$t('mailer.sender.table.deactivate')"
      >
        <table-control type="trash" @click="deactivate(item)" />
      </tooltip>
      <tooltip
        v-else-if="needShowDelete(item)"
        placement="left"
        theme="light"
        :content="$t('shared.component.table.action.delete')"
      >
        <table-control type="trash" @click="deleteSender(item)" />
      </tooltip>
      <tooltip
        v-else-if="
          item.status === 'new' || item.status === 'canceled' || item.status === 'deactivated'
        "
        placement="left"
        theme="light"
        :content="$t('shared.component.table.action.delete')"
      >
        <table-control type="trash" @click="deleteSender(item)" />
      </tooltip>
    </template>
  </vuex-table>
</template>

<script>
  import { mapActions } from 'vuex';
  import StateBadge from '@mailer/components/senders/senders-badge-state';
  import { SenderModalService } from '@mailer/modals/SenderModalService';

  export default {
    components: { StateBadge },
    data: () => ({
      updated_senders: []
    }),
    computed: {
      fields: function () {
        return [
          {
            key: 'name',
            label: this.$t('mailer.sender.table.name'),
            sortable: true,
            class: 'w-50'
          },
          {
            key: 'status',
            label: this.$t('shared.component.table.field.status'),
            sortable: true,
            class: 'w-25'
          },
          {
            key: 'created_at',
            label: this.$t('shared.component.table.field.created_at'),
            sortable: true,
            class: 'w-25'
          },
          {
            key: 'external_description',
            label: this.$t('mailer.sender.table.description'),
            class: 'w-25'
          },
          {
            key: 'sender_vendors',
            label: this.$t('mailer.sender.table.cost'),
            class: 'w-25',
            formatter: (value) => {
              if (Array.isArray(value) && value.length > 0) {
                let sum = (a) => a.reduce((x, y) => x + y);
                let totalAmount = sum(value.map((x) => Number(x.connection_cost)));
                return totalAmount.toFixed(2);
              } else {
                return '';
              }
            }
          },
          {
            key: 'actions',
            label: this.$t('shared.component.table.actions'),
            class: 'table-actions'
          }
        ];
      }
    },
    created() {
      this.$socket.client.on(`zrr.notify.notifications:${this.$user.user_key}`, (payload) => {
        const type = this.$R.pathOr('', ['data', 'type'], payload);
        const id = this.$R.pathOr('', ['data', 'params', 'id'], payload);
        const status = this.$R.pathOr('', ['data', 'params', 'status'], payload);

        if (type === 'senders_update') {
          this.updated_senders = [{ id, status }, ...this.updated_senders];
        }
      });
    },

    methods: {
      ...mapActions('mailer/senders/table', ['getAsyncData']),
      needShowDeactivate(item) {
        return this.updated_senders.find((sender) => sender.id === item.id)?.status === 'active';
      },
      needShowDelete(item) {
        const status = this.updated_senders.find((sender) => sender.id === item.id)?.status;
        return status === 'new' || status === 'canceled' || status === 'deactivated';
      },
      deactivate: function (item) {
        SenderModalService.deactivate(item.id, item).on('success', () => {
          this.$noty.info(
            this.$t('notify.notification.senders_update.on_deactivation', {
              name: item.name
            })
          );
          return this.getAsyncData();
        });
      },
      deleteSender: function (item) {
        SenderModalService.remove(item.id, item).on('success', () => this.getAsyncData());
      }
    }
  };
</script>